/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const root = (typeof window !== "undefined") ? window : globalThis;

const initClock = function() {
  root.canvas = $('#clock-canvas')[0];
  root.ctx = root.canvas.getContext('2d');
  root.radius = root.canvas.height / 2;
  ctx.translate(root.radius, root.radius);
  root.radius = root.radius * 0.90;

  const now = new Date;
  root.hour = now.getHours();
  root.minute = now.getMinutes();

  return root.intervalId = setInterval(drawClock, 50);
};


root.stopClock = () => clearInterval(root.intervalId);

var drawClock = function() {
  root.minute = root.minute + 5;
  if (root.minute >= 60) {
    root.minute = 0;
    root.hour = (root.hour + 1) % 12;
  }

  drawFace(root.ctx, root.radius);
  drawNumbers(root.ctx, root.radius);
  drawTime(root.ctx, root.radius);
};

var drawFace = function(ctx, radius) {
  let grad = undefined;
  ctx.beginPath();
  ctx.arc(0, 0, radius, 0, 2 * Math.PI);
  ctx.fillStyle = 'white';
  ctx.fill();
  grad = ctx.createRadialGradient(0, 0, radius * 0.95, 0, 0, radius * 1.05);
  grad.addColorStop(0, '#333');
  grad.addColorStop(0.5, 'white');
  grad.addColorStop(1, '#999');
  ctx.strokeStyle = grad;
  ctx.lineWidth = radius * 0.1;
  ctx.stroke();
  ctx.beginPath();
  ctx.arc(0, 0, radius * 0.1, 0, 2 * Math.PI);
  ctx.fillStyle = '#000';
  ctx.fill();
};

var drawNumbers = function(ctx, radius) {
  let ang = undefined;
  let num = undefined;
  ctx.font = (radius * 0.15) + 'px arial';
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  num = 1;
  while (num < 13) {
    ang = (num * Math.PI) / 6;
    ctx.rotate(ang);
    ctx.translate(0, -radius * 0.85);
    ctx.rotate(-ang);
    ctx.fillText(num.toString(), 0, 0);
    ctx.rotate(ang);
    ctx.translate(0, radius * 0.85);
    ctx.rotate(-ang);
    num++;
  }
};

var drawTime = function(ctx, radius) {
  const now = new Date;
  let {
    hour
  } = root;
  let {
    minute
  } = root;

  //hour
  hour = hour % 12;
  hour = ((hour * Math.PI) / 6) + ((minute * Math.PI) / (6 * 60));
  drawHand(ctx, hour, radius * 0.5, radius * 0.07);
  //minute
  minute = (minute * Math.PI) / 30;
  drawHand(ctx, minute, radius * 0.8, radius * 0.07);
};

var drawHand = function(ctx, pos, length, width) {
  ctx.beginPath();
  ctx.lineWidth = width;
  ctx.lineCap = 'round';
  ctx.moveTo(0, 0);
  ctx.rotate(pos);
  ctx.lineTo(0, -length);
  ctx.stroke();
  ctx.rotate(-pos);
};


const customerTypeChanged = function() {
  const val = $("input[name='demo_request[customer_type]']:checked").val();
  if ((val === "city") || (val === "town") || (val === "county")) {
    enableInputWrapper($("#organization .district"));
    disableInputWrapper($("#organization .organization"));
    disableInputWrapper($("#organization-address"));
    return disableInputWrapper($("#non-gov"));

  } else if (val === "individual") {
    disableInputWrapper($("#organization .district"));
    disableInputWrapper($("#organization .organization"));
    enableInputWrapper($("#organization-address"));
    return disableInputWrapper($("#non-gov"));

  } else if (val === "non_gov") {
    disableInputWrapper($("#organization .district"));
    disableInputWrapper($("#organization .organization"));
    enableInputWrapper($("#organization-address"));
    return enableInputWrapper($("#non-gov"));

  } else if (val !== "") {
    disableInputWrapper($("#organization .district"));
    disableInputWrapper($("#non-gov"));
    enableInputWrapper($("#organization .organization"));
    return enableInputWrapper($("#organization-address"));
  }
};

root.editFormHandler= function() {
  const $form = $('.edit_demo_request');
  const $communityInputs = $form.find('.address-picker');
  return $communityInputs.each(function() {
    const input = $(this);
    const selectedCommunity = input.val();
    const autocomplete = new google.maps.places.Autocomplete(input[0], ['geocode']);
    return autocomplete.addListener('place_changed', function() {
      if (selectedCommunity !== input.val()) {
        return $('input[name="id"]').val('');
      }
    });
  });
};

root.initDemoRequest = function() {
  $("input[name='demo_request[customer_type]']").change(() => customerTypeChanged());

  editFormHandler();

  const $el = $('.demo').find('form.edit_demo_request, form.new_demo_request');
  return $el.find('.submit').click(() => startLoader($el));
};

root.refreshDemoSurvey = function() {
  const $el = $('#refresh-demo-survey');
  const path = $el.data('path');

  if (path) {
    return $.post(path, "", "OK", 'script');
  }
};

root.initRefreshDemoSurvey = function() {

  window.setTimeout((() => refreshDemoSurvey()), 4000);
  if (!window.DISABLE_ANIMATIONS && !window.DISABLE_AJAX_LOADER) {
    return $('#loading').fadeIn();
  }
};

root.removeResultsTour = function() {
  const tour = $('#results-tour');
  if (!$('.demo-tour:visible').length && tour.length) {
    return tour.remove();
  }
};

if ($('#clock-canvas').length) {
  window.DISABLE_AJAX_LOADER = true;
}

/*
(function() {
  if ($(".new_demo_request, .edit_demo_request").length) {
    initDemoRequest();
    customerTypeChanged();
  }
  if ($("#refresh-demo-survey").length) {
    initRefreshDemoSurvey();
  }
  if ($('#clock-canvas').length) {
    initClock();
  }
  if ($('#results-tour').length) {
    return removeResultsTour();
  }
});
*/

function initDemoOnLoad() {
  if ($(".new_demo_request, .edit_demo_request").length) {
    initDemoRequest();
    customerTypeChanged();
  }
  if ($("#refresh-demo-survey").length) {
    initRefreshDemoSurvey();
  }
  if ($('#clock-canvas').length) {
    initClock();
  }
  if ($('#results-tour').length) {
    return removeResultsTour();
  }
}

$(initDemoOnLoad);
document.addEventListener('turbo:load', initDemoOnLoad);
